<template>
  <div class="app-monitor">
    <TopBar />
    <div class="monitor-container">
      <!-- 左侧导航栏 -->
      <div class="sidebar">
        <!-- <div class="logo">LOGO</div> -->
        <div class="nav-item" @click="goToIssueList">
          <div class="nav-icon">
            <img
              src="../assets/alarmMonitor.svg"
              style="width: 100%; height: 100%"
              alt=""
              srcset=""
            />
          </div>
          <span>问题与故障</span>
        </div>
        <div class="nav-item active" @click="goToApiList">
          <div class="nav-icon">
            <img
              src="../assets/接口监控-b.svg"
              style="width: 100%; height: 100%"
              alt=""
              srcset=""
            />
          </div>
          <span>接口监控</span>
        </div>
        <div class="nav-item">
          <div class="nav-icon"></div>
          <span>看板</span>
        </div>
      </div>

      <!-- 右侧内容区域 -->
      <div class="content">
        <!-- 列表视图 -->
        <div v-if="!showDetail" key="list-view">
          <h1>接口监控</h1>

          <!-- 筛选条件 -->
          <div class="filter-section-map">
            <div class="filter-section">
              <el-input v-model="sessionId" clearable placeholder="会话id" style="width: 150px;"></el-input>
              <el-input v-model="sdkInfo" clearable placeholder="APP信息" style="width: 150px;"></el-input>
              <el-select
                v-model="brandValue"
                placeholder="手机厂商"
                style="width: 150px"
                clearable
              >
                <el-option
                  v-for="item in brandOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                />
              </el-select>
              <el-select
                v-model="modelValue"
                placeholder="手机型号"
                style="width: 150px"
                clearable
              >
                <el-option
                  v-for="item in modelOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                />
              </el-select>
              <el-select
                v-model="uuidValue"
                placeholder="UUID"
                style="width: 150px"
                clearable
              >
                <el-option
                  v-for="item in uuidOptions"
                  :key="item"
                  :label="item"
                  :value="item"
                />
              </el-select>
              <el-select
                v-model="timeValue"
                placeholder="时间"
                style="width: 150px"
                @change="selectAll"
              >
                <el-option
                  v-for="item in timeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
              <el-select
                v-model="sortValue"
                placeholder="排序"
                style="width: 150px"
              >
                <el-option
                  v-for="item in sortOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
              <el-button type="primary" @click="fetchApiList">查询</el-button>
            </div>
          </div>

          <!-- 接口列表表格  @row-click="showApiDetail"-->
          <div class="table-container">
            <el-table
              :data="apiTableData"
              style="width: 100%; cursor: pointer"
              height="580"
            >
              <el-table-column label="会话列表" min-width="100">
                <template #default="scope">
                  <p class="session-link">
                    {{ scope.row.sessionId }}
                  </p>
                </template>
              </el-table-column>
              <el-table-column label="接口" min-width="200">
                <template #default="scope">
                  <div class="api-list">
                    <div
                      v-for="(api, index) in scope.row.apis"
                      :key="index"
                      class="api-item"
                    >
                      <span :class="['api-icon', api.status]"></span>
                      <span
                        >{{ api.name }}({{ api.desc }}) * {{ api.count }}</span
                      >
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="会话发生时间" width="120">
                <template #default="scope">
                  {{ scope.row.time }}
                </template>
              </el-table-column>
              <el-table-column label="最高耗时接口" min-width="150">
                <template #default="scope">
                  <div class="slow-api-list">
                    <div
                      v-for="(api, index) in scope.row.slowApis"
                      :key="index"
                      class="slow-api-item"
                    >
                      <span :class="['api-icon', api.status]"></span>
                      <span>{{ api.name }}</span>
                      <span class="api-time">{{ api.time }}ms</span>
                    </div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="手机信息" width="200" >
                <template #default="scope">
                  <div>{{ scope.row.phoneModel }}</div>
                  <div>{{ scope.row.androidVersion }}</div>
                  <div>操作系统: {{ scope.row.osVersion }}</div>
                </template>
              </el-table-column>
              <el-table-column label="APP信息" width="200">
                <template #default="scope">
                   <p>应用名称:{{ scope.row.sdkName }}</p>
                   <p>版本信息:{{ scope.row.appVersion }}</p>
                   <p v-if="scope.row.sdkLanguage">默认语言:{{ scope.row.sdkLanguage =='zh'?'中文':scope.row.sdkLanguage =='en'?'英文':'俄文' }}</p>
                </template>
              </el-table-column>
              <!-- <el-table-column
                prop="sdkLanguage"
                label="SDK默认语言"
                width="150"
                align="center"
              /> -->
              <el-table-column
                prop="errorCount"
                label="操作"
                min-width="250"
                align="center"
              >
                <template #default="scope">
                  <div style="display: flex; justify-content: space-between">
                    <p
                      class="errorCountCaoZuo"
                      style="color: #3da8ff; cursor: pointer"
                      @click="showApiDetail(scope.row)"
                    >
                      详情
                    </p>
                    <p
                      class="errorCountCaoZuo"
                      style="color: #3da8ff; cursor: pointer"
                      @click="DownloadLog(scope.row)"
                      v-show="scope.row.logsDownUrl"
                    >
                      复制下载日志链接
                    </p>
                    <p
                      class="errorCountCaoZuo"
                      style="color: #3da8ff; cursor: pointer"
                      @click="DownBDloadLog(scope.row)"
                      v-show="scope.row.dbDownUrl"
                    >
                      复制下载数据库链接
                    </p>
                  </div>
                </template>
              </el-table-column>
            </el-table>

            <!-- 分页组件 -->
            <div class="pagination-container">
              <el-pagination
                v-model:current-page="currentPage"
                v-model:page-size="pageSize"
                :page-sizes="[10, 20, 50, 100]"
                :total="totalCount"
                layout="total, sizes, prev, pager, next, jumper"
                @size-change="handleSizeChange"
                @current-change="handlePageChange"
              />
            </div>
          </div>
        </div>

        <!-- 详情视图 -->
        <div v-else key="detail-view">
          <div v-if="showApiDetailRow && showApiDetailRow.sessionId">
            <div style="display: flex; justify-content: space-between">
              <div class="Api-top">
                <h1
                  style="cursor: pointer; text-decoration: underline"
                  class="BackToUN"
                  @click="goToApiList"
                >
                  接口监控
                </h1>
                <h1 style="margin-left: 5px; margin-right: 5px">/</h1>
                <h1 class="current">详情</h1>
              </div>
              <el-button @click="goToApiList">返回</el-button>
            </div>
            <div class="info-title">
              <h1>信息</h1>
            </div>
            <div class="Api-bottom">
              <div class="ApiID-bottom">
                <div class="api-id-text">
                  ID:{{ showApiDetailRow.sessionId }}
                </div>
                <div></div>
                <div>
                  <el-button
                    type="primary"
                    plain
                    v-if="sortValue === 'time_asc'"
                    @click="Descending"
                    >倒序</el-button
                  >
                  <el-button type="primary" plain v-else @click="Ascending"
                    >正序</el-button
                  >
                </div>
              </div>
              <div class="ApiLONLNG">
                <div class="location-wrapper">
                  <div class="icon-box">
                    <el-icon color="#7000ff">
                      <QuestionFilled />
                    </el-icon>
                  </div>
                  <div class="location-content">
                    <div class="ip-address">
                      {{ treeData[0].lng }},{{ treeData[0].lat }}
                    </div>
                    <div class="location-text">
                      <span v-if="result"
                        >{{ result.provinceName }},{{ result.cityName }}</span
                      >
                      <span
                        style="
                          margin-left: 20px;
                          cursor: pointer;
                          color: #3da8ff;
                        "
                        @click="PositionLeflat"
                      >
                        位置
                      </span>
                    </div>
                  </div>
                </div>
                <div class="device-model">
                  手机型号: {{ showApiDetailRow.deviceBrand }}
                </div>
                <div class="os-version">
                  操作系统版本: {{ showApiDetailRow.osVersion }}
                </div>
              </div>
              <div class="Time-Api">
                <div style="margin-left: 1%; font-weight: 700">瀑布图</div>
                <div
                  style="
                    margin-left: 1%;
                    width: 98%;
                    margin-top: 10px;
                    margin-bottom: 10px;
                  "
                >
                  <el-input
                    v-model="responsiveinput"
                    class="responsive-input"
                    placeholder="Type something"
                    @change="showApiDetail()"
                  >
                    <template #prefix>
                      <el-icon class="el-input__icon"><search /></el-icon>
                    </template>
                  </el-input>
                </div>
                <div
                  style="
                    width: 98%;
                    height: 500px;
                    background-color: transparent;
                    margin-left: 1%;
                    border: 1px solid #e0e0e0;
                    border-radius: 4px;
                    overflow-y: auto;
                    overflow-x: hidden;
                    position: relative;
                  "
                >
                  <div
                    style="
                      width: 50%;
                      background-color: transparent;
                      height: 100%;
                      position: absolute;
                      top: 0;
                    "
                    :style="{
                      width: showApiDetailDialog
                        ? `calc(${leftWidth + '%'} - 50px)`
                        : leftWidth + '%',
                    }"
                  >
                    <div
                      class="resize-bar"
                      :style="{ left: 100 + '%', height: minHeightLine + 'px' }"
                      @mousedown="startResize"
                    ></div>
                    <div style="margin-top: 40px">
                      <div
                        v-for="item in flatTreeList"
                        :key="item.id"
                        class="timeline-row"
                        :class="{
                          'row-hover-active': hoverRowId === item.id,
                          'row-active':
                            checkResultStatus(item) == 'success' &&
                            activeRowId === item.id,
                          'row-timeout':
                            checkResultStatus(item) == 'timeout' &&
                            activeRowId === item.id,
                          'row-error':
                            checkResultStatus(item) == 'error' &&
                            activeRowId === item.id,
                        }"
                        @mouseenter="hoverRowId = item.id"
                        @mouseleave="hoverRowId = null"
                        @click="showApiItemDetail(item)"
                        style="
                          font-size: 14px;
                          line-height: 20px;
                          padding-left: 10px;
                        "
                        :style="{
                          color:
                            checkResultStatus(item) == 'error'
                              ? 'red'
                              : checkResultStatus(item) == 'timeout'
                              ? 'red'
                              : 'black',
                        }"
                      >
                        <div
                          style="
                            display: flex;
                            width: 35%;
                            background-color: rgba(0, 0, 0, 0);
                            float: left;
                            margin-top: 3px;
                          "
                        >
                          <img
                            src="../assets/正确.svg"
                            alt=""
                            style="width: 15px; height: 15px; margin-top: 3px"
                            v-if="checkResultStatus(item) == 'success'"
                          /><img
                            src="../assets/注意.svg"
                            alt=""
                            style="width: 15px; height: 15px; margin-top: 3px"
                            v-if="checkResultStatus(item) == 'timeout'"
                          /><img
                            src="../assets/错误.svg"
                            alt=""
                            style="width: 15px; height: 15px; margin-top: 3px"
                            v-if="checkResultStatus(item) == 'error'"
                          />
                          {{ item.api_description }}
                        </div>
                        <div style="width: 40%; text-align: left; float: left">
                          {{ item.api_method }}
                        </div>
                        <div style="width: 10%; float: right; text-align: left">
                          {{ item.api_duration }}ms
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    style="
                      height: 100%;
                      background-color: transparent;
                      padding-right: 50px;
                      position: absolute;
                      top: 0;
                    "
                    :style="{
                      width: showApiDetailDialog
                        ? `calc(${70 - leftWidth}% - 50px)`
                        : `calc(${100 - leftWidth}% - 50px)`,
                      right: showApiDetailDialog ? `calc(30% + 50px)` : 0,
                    }"
                  >
                    <div class="timeline-header" ref="timelineHeader">
                      <div
                        v-for="item in timeMarks"
                        :key="item.value"
                        class="time-mark"
                        :style="{ left: item.percent + '%' }"
                      >
                        <div
                          class="tick-line"
                          :style="{ height: minHeightLine + 'px' }"
                        ></div>
                        <div class="tick-text">{{ item.display }}</div>
                      </div>
                    </div>

                    <div class="timeline-body">
                      <div
                        v-for="item in flatTreeList"
                        :key="item.id"
                        class="timeline-row"
                        :class="{
                          'row-hover-active': hoverRowId === item.id,
                          'row-active':
                            checkResultStatus(item) == 'success' &&
                            activeRowId === item.id,
                          'row-timeout':
                            checkResultStatus(item) == 'timeout' &&
                            activeRowId === item.id,
                          'row-error':
                            checkResultStatus(item) == 'error' &&
                            activeRowId === item.id,
                          'row-error-list':
                            checkResultStatus(item) == 'error' &&
                            activeRowId === item.id,
                          'row-timeout-list':
                            checkResultStatus(item) == 'timeout' &&
                            activeRowId === item.id,
                          'row-activess':
                            checkResultStatus(item) == 'success' &&
                            activeRowId === item.id,
                        }"
                        @mouseenter="hoverRowId = item.id"
                        @mouseleave="hoverRowId = null"
                        @click="showApiItemDetail(item)"
                      >
                        <div
                          class="timeline-block"
                          :style="getBlockStyle(item)"
                          :title="`${item.api_description} ${item.startTime}ms - ${item.endTime}ms`"
                          v-show="item.endTime != 0"
                        >
                          {{ item.endTime }}ms
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- :style="{ height: minHeightLine + 'px' }" -->
                  <div
                    style="
                      width: 26%;
                      height: 460px;
                      background-color: #fff;
                      padding: 20px;
                      position: fixed;
                      bottom: 83px;
                      right: 55px;
                      overflow-y: auto;
                      border-left: 1px solid #e0e0e0;
                    "
                    v-if="showApiDetailDialog"
                  >
                    <div class="api-detail-panel">
                      <img
                        src="../assets/关闭.svg"
                        style="
                          width: 20px;
                          height: 20px;
                          position: absolute;
                          right: 5px;
                          top: 5px;
                        "
                        alt=""
                        @click="guanbiFalse"
                      />
                      <div class="api-header">
                        <div class="api-name">
                          <el-tag
                            size="small"
                            :type="
                              checkResultStatus(selectedApiItem) == 'error'
                                ? 'danger'
                                : checkResultStatus(selectedApiItem) ==
                                  'timeout'
                                ? 'warning'
                                : 'success'
                            "
                            >{{ selectedApiItem.api_description }}</el-tag
                          >
                        </div>
                        <div class="api-desc">
                          {{ selectedApiItem.api_description }}接口介绍内容
                        </div>
                        <div class="api-time">
                          耗时:
                          <span class="time-value"
                            >{{ selectedApiItem.api_duration }}ms</span
                          ><span class="time-value" style="margin-left: 20px">{{
                            moment(selectedApiItem.requestTimeInt).format(
                              "YYYY-MM-DD HH:mm:ss"
                            )
                          }}</span>
                        </div>
                      </div>

                      <el-collapse v-model="activeCollapse">
                        <el-collapse-item title="附加参数" name="params">
                          <!-- <div
                            v-for="(value, key) in JSON.parse(
                              selectedApiItem.api_params
                            )"
                            :key="key"
                            class="detail-item"
                          >
                            <span class="detail-label">{{ key }}:</span>
                            <span class="detail-value">{{ value }}</span>
                          </div> -->
                          <VueJsonPretty
                            :data="JSON.parse(selectedApiItem.api_params)"
                            :deep="1"
                          />
                        </el-collapse-item>
                        <el-collapse-item title="返回结果" name="result">
                          <!-- <div
                            v-for="(value, key) in JSON.parse(
                              selectedApiItem.api_response
                            )"
                            :key="key"
                            class="detail-item"
                          >
                            <span class="detail-label">{{ key }}:</span>
                            <span class="detail-value">{{ value }}</span>
                          </div> -->
                          <VueJsonPretty
                            :data="JSON.parse(selectedApiItem.api_response)"
                            :deep="1"
                          />
                        </el-collapse-item>
                        <el-collapse-item
                          title="错误"
                          name="resultss"
                          v-if="checkResultStatus(selectedApiItem) == 'error'"
                        >
                          <el-tag
                            size="small"
                            :type="
                              checkResultStatus(selectedApiItem) == 'error'
                                ? 'danger'
                                : checkResultStatus(selectedApiItem) ==
                                  'timeout'
                                ? 'warning'
                                : 'success'
                            "
                            >{{ selectedApiItem.api_error }}</el-tag
                          >
                        </el-collapse-item>
                        <el-collapse-item
                          title="告警"
                          name="resultest"
                          v-if="checkResultStatus(selectedApiItem) == 'timeout'"
                        >
                          <el-tag
                            size="small"
                            :type="
                              checkResultStatus(selectedApiItem) == 'error'
                                ? 'danger'
                                : checkResultStatus(selectedApiItem) ==
                                  'timeout'
                                ? 'warning'
                                : 'success'
                            "
                            >{{ selectedApiItem.api_warnerror }}</el-tag
                          >
                        </el-collapse-item>
                      </el-collapse>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 地图弹框 -->
    <el-dialog
      v-model="showMapDialog"
      title="错误发生点位"
      width="800px"
      height="600px"
    >
      <div id="map" style="width: 100%; height: 500px"></div>
    </el-dialog>
  </div>
</template>

<script>
import TopBar from "./Top.vue";
import {
  getFailApiList,
  getDateTypeValue,
  formatApiList,
  getfailApiDetail,
  getselectAllList,
} from "@/api/appError.js";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import "leaflet.chinatmsproviders";
import "../data/leaflet.mapCorrection.js";
import moment from "moment";
import rawData from "../data/city_geo_range.json";
import VueJsonPretty from "vue-json-pretty";
import { enrichProvinceBounds, findLocationSafe } from "../utils/geoLocation";
import axios from "axios";

export default {
  name: "ApiMonitor",
  components: {
    TopBar,
    VueJsonPretty,
  },
  data() {
    return {
      moment: moment,
      showDetail: false,
      loading: false,
      currentPage: 1,
      pageSize: 10,
      totalCount: 0,
      sectionValue: "",
      brandValue: "",
      sessionId:'',
      sdkInfo:'',
      modelValue: "",
      uuidValue: "",
      timeValue: "15min",
      sortValue: "time_desc",
      leftWidth: 30,
      activeTab: "request",
      activeCollapse: ["body"],
      requestParams: [
        {
          name: "username",
          type: "String",
          required: "是",
          description: "用户名",
          value: "admin",
        },
        {
          name: "password",
          type: "String",
          required: "是",
          description: "密码",
          value: "******",
        },
        {
          name: "captcha",
          type: "String",
          required: "否",
          description: "验证码",
          value: "1234",
        },
        {
          name: "deviceId",
          type: "String",
          required: "否",
          description: "设备ID",
          value: "android_xxx",
        },
        {
          name: "deviceType",
          type: "String",
          required: "否",
          description: "设备类型",
          value: "Android",
        },
        {
          name: "appVersion",
          type: "String",
          required: "否",
          description: "APP版本",
          value: "3.0.7",
        },
      ],
      responseBody: {
        code: 200,
        message: "登录成功",
        data: {
          token: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9...",
          userId: 1001,
          username: "admin",
          nickname: "管理员",
          avatar: "https://xxx.com/avatar.jpg",
          roles: ["admin"],
          permissions: ["*:*:*"],
        },
        timestamp: 1705297825123,
      },
      tableData: [
        {
          date: "2023-10-10 10:00:00",
          name: "user.login",
          address: "XXX.XXX(API介绍) * 1",
        },
        {
          date: "2023-10-10 10:01:00",
          name: "XXX.XXX",
          address: "yyy.yyy(API介绍) * 5",
        },
      ],
      apiTableData: [],
      timeOptions: [
        { value: "15min", label: "15分钟" },
        { value: "1h", label: "1小时" },
        { value: "24h", label: "24小时" },
        { value: "1week", label: "1周" },
        { value: "1month", label: "1月" },
        { value: "1year", label: "1年" },
      ],
      sortOptions: [
        { value: "time_desc", label: "时间倒序" },
        { value: "time_asc", label: "时间正序" },
      ],
      brandOptions: [],
      modelOptions: [{ value: "", label: "全部" }],
      uuidOptions: [{ value: "", label: "全部" }],
      defaultProps: {
        children: "children",
        label: "label",
      },
      treeData: [],
      timelineWidth: 0,
      maxTime: 100,
      totalTime: 200,
      hoverRowId: null,
      activeRowId: null,
      flatTreeList: [],
      minHeightLine: 500,
      showApiDetailDialog: false,
      selectedApiItem: null,
      showApiDetailRow: {},
      responsiveinput: "",
      rowListApi: {},
      result: {},
      map: null,
      showMapDialog: false,
      downloadLoading: false,
    };
  },
  watch: {
    flatTreeList: {
      handler() {
        this.setMinHeight();
      },
      deep: true,
      immediate: true,
    },
  },
  computed: {
    /* timeMarks() {
      let result = [];

      let step = 10;
      let useSecond = false;

      if (this.maxTime > 10000) {
        step = 10000;
        useSecond = true;
      } else if (this.maxTime > 1000) {
        step = 1000;
      } else if (this.maxTime > 100) {
        step = 100;
      }

      for (let index = 0; index * step < this.maxTime; index++) {
        const value = index * step;

        result.push({
          value, // ✅ 仍然是毫秒（用于计算）
          display: useSecond ? (value / 1000).toFixed(1) + "s" : value + "ms",
          percent:
            (value / ((Math.floor(this.maxTime / step) + 1) * step)) * 100,
        });
      }

      // ✅ totalTime 继续用毫秒（完全不动）
      if (result.length > 0) {
        this.totalTime = result[result.length - 1].value + step;
      } else {
        this.totalTime = step;
      }

      return result;
    }, */
    timeMarks() {
      const result = [];

      const steps = [
        10,
        50,
        100,
        500,
        1000,
        5000,
        10000,
        30000,
        60000,
        300000,
        600000,
        1800000,
        3600000,
        7200000,
        21600000,
        43200000,
        86400000, // 1天
        172800000, // 2天
        604800000, // 7天
      ];

      const targetCount = 8;

      let step = steps[0];

      for (const s of steps) {
        if (this.maxTime / s <= targetCount) {
          step = s;
          break;
        }
        step = s;
      }

      const total = Math.ceil(this.maxTime / step) * step || step;

      for (let value = 0; value <= total; value += step) {
        result.push({
          value,
          display: this.formatTime(value),
          percent: total === 0 ? 0 : (value / total) * 100,
        });
      }

      this.totalTime = total;

      return result;
    },
    flatTreeList() {
      const result = [];

      const loop = (list, level = 0) => {
        list.forEach((item) => {
          result.push({
            ...item,
            level,
          });
          if (item.children && item.children.length) {
            loop(item.children, level + 1);
          }
        });
      };
      console.log(result, "fdsjifjsifjisjfisdjf");
      loop(this.treeData);
      return result;
    },
  },
  methods: {
    PositionLeflat() {
      this.showMapDialog = true;
      this.$nextTick(() => {
        if (this.map) {
          this.map.remove();
        }
        const lat = this.treeData[0].lat;
        const lng = this.treeData[0].lng;
        if (lat && lng && lat != "undefined" && lng != "undefined") {
          this.map = L.map("map").setView([lat, lng], 15);
          L.tileLayer
            .chinaProvider("GaoDe.Normal.Map", {
              attribution: "",
            })
            .addTo(this.map);
          L.circleMarker([lat, lng], {
            radius: 8,
            fillColor: "#ff0000",
            color: "#000",
            weight: 1,
            opacity: 1,
            fillOpacity: 0.8,
          }).addTo(this.map);
        } else {
          // this.showMapDialog = false;
        }
      });
    },
    formatTime(ms) {
      const day = 24 * 60 * 60 * 1000;
      const hour = 60 * 60 * 1000;
      const minute = 60 * 1000;

      if (ms < 1000) {
        return ms + "ms";
      } else if (ms < minute) {
        return this.formatNumber(ms / 1000) + "s";
      } else if (ms < hour) {
        return this.formatNumber(ms / minute) + "min";
      } else if (ms < day) {
        return this.formatNumber(ms / hour) + "h";
      } else {
        return this.formatNumber(ms / day) + "d"; // 👈 天
      }
    },

    formatNumber(num) {
      return Number.isInteger(num)
        ? String(num)
        : num.toFixed(1).replace(/\.0$/, "");
    },
    Descending() {
      this.sortValue = "time_desc";
      this.showApiDetail();
    },
    async DownloadLog(row) {
      if (!row.logsDownUrl) {
        this.$message.error("日志地址不存在");
        return;
      }
      try {
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(row.logsDownUrl);
        } else {
          const textarea = document.createElement("textarea");
          textarea.value = row.logsDownUrl;
          textarea.style.position = "fixed";
          textarea.style.opacity = "0";
          document.body.appendChild(textarea);
          textarea.select();
          document.execCommand("copy");
          document.body.removeChild(textarea);
        }
        this.$message.success("日志链接已复制，请在浏览器新标签页打开");
      } catch (error) {
        console.error("复制失败:", error);
        this.$message.error("复制日志链接失败");
      }
    },
    async DownBDloadLog(row) {
      if (!row.dbDownUrl) {
        this.$message.error("数据库地址不存在");
        return;
      }
      try {
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(row.dbDownUrl);
        } else {
          const textarea = document.createElement("textarea");
          textarea.value = row.dbDownUrl;
          textarea.style.position = "fixed";
          textarea.style.opacity = "0";
          document.body.appendChild(textarea);
          textarea.select();
          document.execCommand("copy");
          document.body.removeChild(textarea);
        }
        this.$message.success("数据库链接已复制，请在浏览器新标签页打开");
      } catch (error) {
        console.error("复制失败:", error);
        this.$message.error("复制数据库链接失败");
      }
    },
    
    Ascending() {
      this.sortValue = "time_asc";
      this.showApiDetail();
    },
    guanbiFalse() {
      this.showApiDetailDialog = false;
    },
    async selectAll() {
      try {
        let params = {
          dateType: getDateTypeValue(this.timeValue),
          source: 1,
        };
        const response = await getselectAllList(params);
        if (response.data.code == 200) {
          this.brandOptions = response.data.data.brandList;
          this.modelOptions = response.data.data.modelList;
          this.uuidOptions = response.data.data.uuidList;
          console.log(response.data.data, "fdsfijdsifjisdfsdfdsfs");
        }
      } catch (error) {
        console.error("获取选择项失败:", error);
      }
    },
    setMinHeight() {
      this.$nextTick(() => {
        const container = this.$el.querySelector(".timeline-body");
        if (!container) return;

        const height = container.offsetHeight + 50;
        console.log("当前高度：", height);
        this.minHeightLine = height;

        if (height < 500) {
          container.style.minHeight = "500px";
          this.minHeightLine = 500;
        } else {
          container.style.minHeight = "";
        }
      });
    },
    updateTimelineWidth() {
      this.$nextTick(() => {
        const el = this.$refs.timelineHeader;
        if (el) {
          this.timelineWidth = el.clientWidth;
        }
      });
    },
    getBlockStyle(item) {
      const left = (item.startTime / this.totalTime) * 100;
      const width = (item.api_duration / this.totalTime) * 100;
      console.log(
        item,
        item.startTime,
        left,
        width,
        this.totalTime,
        "fdjsifjdisjfisjfidjisdfs"
      );
      return {
        left: left + "%",
        width: width + "%",
        backgroundColor: this.getColor(item.level),
      };
    },
    getColor(level) {
      const colors = ["#409EFF", "#67C23A", "#E6A23C", "#F56C6C", "#909399"];
      return colors[level % colors.length];
    },
    startResize(e) {
      const startX = e.clientX;
      const startWidth = this.leftWidth;

      const minWidth = 28; // %
      const maxWidth = 80; // %

      const onMouseMove = (e) => {
        const moveX = ((e.clientX - startX) / document.body.clientWidth) * 100;

        /* const newWidth = Math.round(startWidth + moveX); // 四舍五入 */
        const newWidth = Number((startWidth + moveX).toFixed(1));

        this.leftWidth = Math.min(Math.max(newWidth, minWidth), maxWidth);
      };

      const onMouseUp = () => {
        document.removeEventListener("mousemove", onMouseMove);
        document.removeEventListener("mouseup", onMouseUp);
      };

      document.addEventListener("mousemove", onMouseMove);
      document.addEventListener("mouseup", onMouseUp);
    },
    goToIssueList() {
      this.$router.push("/app-monitor");
    },
    goToApiList() {
      // this.$router.push("/api-monitor");
      this.backToList();
    },
    async fetchApiList() {
      this.loading = true;
      try {
        const params = {
          page: this.currentPage,
          limit: this.pageSize,
          order: this.sortValue === "time_desc" ? 0 : 1,
          dateType: getDateTypeValue(this.timeValue),
          brand: this.brandValue,
          model: this.modelValue,
          uuid: this.uuidValue,
          sessionId: this.sessionId,
          sdkInfo: this.sdkInfo,
        };

        const response = await getFailApiList(params);

        if (response.data.code === 200) {
          console.log(response.data.data.data,"fdsjfijsifjsfsfsdfd787f8dsfs");
          this.apiTableData = formatApiList(response.data.data.data);
          this.totalCount = response.data.data.count;
        }
      } catch (error) {
        console.error("获取接口列表失败:", error);
      } finally {
        this.loading = false;
      }
    },
    handlePageChange(page) {
      this.currentPage = page;
      this.fetchApiList();
    },
    handleSizeChange(size) {
      this.pageSize = size;
      this.currentPage = 1;
      this.fetchApiList();
    },
    async showApiDetail(row) {
      console.log(row, "fdsjifjsifjisdjfs");
      if (row) {
        this.rowListApi = row;
      }
      console.log(this.rowListApi, "fdsjifjisjfidsjifjsdfsdfs");
      try {
        const params = {
          order: this.sortValue === "time_desc" ? 0 : 1,
          dateType: getDateTypeValue(this.timeValue),
          brand: this.brandValue,
          model: this.modelValue,
          uuid: this.uuidValue,
          sessionId: this.rowListApi.sessionId,
          searchVal: this.responsiveinput,
        };
        const response = await getfailApiDetail(params);
        // console.log(response, "fdsjfijdsifjidsfds78f78dsf");
        if (response.data.code == 200) {
          console.log(response.data, "fdsjdfidjsifjisdjfisdfsdf");
          this.treeData = response.data.data.detailData;
          if (row) {
            this.showApiDetailRow = row;
          }
          this.maxTime = response.data.data.maxReqTime;
        }
        // ✅ 1. 生成省级范围
        const provinces = enrichProvinceBounds(rawData);

        // ✅ 2. 查询
        this.result = findLocationSafe(
          response.data.data.detailData[0].lat,
          response.data.data.detailData[0].lng,
          provinces
        );
      } catch (error) {
        console.error("获取接口列表失败:", error);
      }
      this.showDetail = true;
      this.setMinHeight();
    },
    backToList() {
      this.showDetail = false;
    },
    showApiItemDetail(item) {
      console.log(item, "fdjsifjdisjfidsjifjsfds");
      this.activeRowId = item.id;
      this.selectedApiItem = item;
      this.showApiDetailDialog = true;
    },
    checkResultStatus(item) {
      let trueORfalse = "success";
      if (item.api_status == "error") {
        trueORfalse = "error";
      } else if (item.api_status == "warn") {
        trueORfalse = "timeout";
      }
      return trueORfalse;
    },
  },
  mounted() {
    this.fetchApiList();
    this.selectAll();
  },
};
</script>

<style scoped lang="less">
.app-monitor {
  padding-top: 60px;
  background-color: #f5f5f5;
  min-height: 100vh;
}

.monitor-container {
  display: flex;
  min-height: calc(100vh - 60px);
}

.sidebar {
  width: 200px;
  background-color: #fff;
  border-right: 1px solid #e0e0e0;
  padding: 20px 0;

  .logo {
    padding: 0 20px 20px;
    font-weight: bold;
    font-size: 18px;
  }

  .nav-item {
    display: flex;
    align-items: center;
    padding: 15px 20px;
    cursor: pointer;
    transition: all 0.3s;

    &:hover {
      background-color: #f0f0f0;
    }

    &.active {
      background-color: #e6f7ff;
      color: #1890ff;
    }

    .nav-icon {
      width: 20px;
      height: 20px;
      background-color: rgba(0, 0, 0, 0);
      margin-right: 10px;
      border-radius: 4px;
    }

    span {
      font-size: 14px;
    }
  }
}

.content {
  flex: 1;
  padding: 20px;
  overflow-y: auto;
  max-height: calc(100vh - 60px);

  h1 {
    color: #333;
    margin-bottom: 20px;
    font-size: 20px;
  }
}

.filter-section {
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
  flex-wrap: wrap;

  .filter-select {
    padding: 8px 12px;
    border: 1px solid #d9d9d9;
    border-radius: 4px;
    font-size: 14px;
    min-width: 120px;
  }

  .search-btn {
    padding: 0 20px;
    background-color: #1890ff;
    color: #fff;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    height: 32px;
  }
}

.table-container {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  margin-top: 20px;
  .errorCountCaoZuo:hover {
    color: #0856ff !important;
    text-decoration: underline !important;
  }
}

.pagination-container {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
  text-align: right;
  padding: 20px;
  background-color: #fff;
  border-radius: 0 0 8px 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  margin-top: -1px;
}

.filter-section-map {
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 20px;
  margin-top: 20px;
}

.filter-section {
  display: flex;
  gap: 10px;
  align-items: center;
  flex-wrap: wrap;
}

.api-list {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.api-item {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 13px;
}

.api-icon {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  display: inline-block;

  &.success {
    background-color: #52c41a;
  }

  &.warning {
    background-color: #faad14;
  }

  &.error {
    background-color: #ff4d4f;
  }
}

.slow-api-list {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.slow-api-item {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 13px;
}

.api-time {
  color: #999;
  font-size: 12px;
  margin-left: 5px;
}

.api-table {
  width: 100%;
  border-collapse: collapse;

  th,
  td {
    padding: 12px;
    text-align: left;
    border-bottom: 1px solid #f0f0f0;
  }

  th {
    background-color: #fafafa;
    font-weight: 600;
    font-size: 14px;
    color: #333;
  }

  td {
    font-size: 14px;
    color: #666;
  }

  .session-link {
    color: #1890ff;
    text-decoration: none;
    font-weight: 500;

    &:hover {
      text-decoration: underline;
    }
  }

  .api-list {
    display: flex;
    flex-direction: column;
    gap: 8px;

    .api-item {
      display: flex;
      align-items: center;
      gap: 8px;
    }
  }

  .slow-api-list {
    display: flex;
    flex-direction: column;
    gap: 8px;

    .slow-api-item {
      display: flex;
      align-items: center;
      gap: 8px;
    }
  }

  .api-icon {
    width: 12px;
    height: 12px;
    border-radius: 50%;

    &.success {
      background-color: #52c41a;
    }

    &.warning {
      background-color: #faad14;
    }
  }

  .api-time {
    color: #999;
    font-size: 12px;
  }
}

.Api-top {
  display: flex;
  height: 40px;
  .BackToUN:hover {
    color: #1890ff;
  }
  .current {
    color: #1890ff;
  }
}

.info-title {
  h1 {
    margin-bottom: 10px;
    margin-top: 10px;
  }
}

.Api-bottom {
  width: 100%;
  height: calc(100vh - 200px);
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  overflow: hidden;

  .ApiID-bottom {
    width: 100%;
    height: 40px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #e0e0e0;

    .api-id-text {
      padding-left: 20px;
      padding-right: 20px;
      font-size: 14px;
      font-weight: 700;
    }
  }

  .ApiLONLNG {
    width: 100%;
    height: 40px;
    display: flex;
    align-items: center;
    border-bottom: 1px solid #e0e0e0;

    .location-wrapper {
      display: flex;
      height: 40px;
      align-items: center;

      .icon-box {
        width: 40px;
        height: 40px;
        text-align: center;
        font-size: 25px;
        line-height: 44px;
      }

      .location-content {
        display: flex;

        .ip-address {
          font-size: 14px;
          font-weight: 700;
          margin-right: 20px;
          margin-left: 5px;
        }

        .location-text {
          font-size: 14px;
          width: 200px;
          text-align: center;
          border-left: 1px solid #e0e0e0;
          border-right: 1px solid #e0e0e0;
        }
      }
    }

    .device-model {
      width: 150px;
      text-align: center;
      border-right: 1px solid #e0e0e0;
      font-size: 14px;
    }

    .os-version {
      width: 350px;
      text-align: center;
      font-size: 14px;
    }
  }
  .Time-Api {
    width: 100%;

    .search-input {
      .el-input__wrapper {
        padding-left: 8px;
      }
      .el-input__wrapper::before {
        content: "🔍";
        position: absolute;
        left: 8px;
        top: 50%;
        transform: translateY(-50%);
        font-size: 14px;
      }
    }
  }
}
.resize-bar {
  position: absolute;
  width: 2px;
  height: 100%;
  cursor: col-resize;
  background: #e0e0e0;
  z-index: 999;
}
.resize-bar:hover {
  background: #409eff;
}

.tree-node {
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding-right: 12px;
  font-size: 14px;
}

.node-time {
  color: #999;
  font-size: 12px;
}

.timeline-header {
  position: relative;
  height: 39px;
  border-bottom: 1px solid #e0e0e0;
  background: #fafafa;
}

.time-mark {
  position: absolute;
  top: 0;
  transform: translateX(-50%);
  line-height: 40px;
}

.tick-line {
  width: 1px;
  height: 500px;
  background: #e0e0e0;
}

.tick-text {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(10%);
  font-size: 12px;
  color: #666;
}

.timeline-body {
  position: relative;
}

.timeline-row {
  position: relative;
  height: 26px;
  border-bottom: 1px solid #f5f5f5;
  box-sizing: border-box;
}

.timeline-line {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-image: linear-gradient(to right, #f0f0f0 1px, transparent 1px);
  background-size: 10% 100%;
}

.timeline-block {
  position: absolute;
  top: 2px;
  height: 20px;
  border-radius: 4px;
  color: #fff;
  font-size: 12px;
  line-height: 20px;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
}

.tree-node,
.timeline-row {
  transition: background-color 0.2s ease;
}

.row-hover-active {
  background-color: #f3edff;
}

.tree-node {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 8px;
  height: 26px;
  // border-radius: 4px;
}

.row-active {
  // background-color: #e9dcff;
  border: 1px solid green;
  box-sizing: border-box;
  border-right: none;
}

.row-timeout {
  border: 1px solid red;
  box-sizing: border-box;
  border-right: none;
}

.row-error {
  border: 1px solid red;
  box-sizing: border-box;
  border-right: none;
}

.row-activess {
  border-right: 1px solid green !important;
}

.row-timeout-list {
  border-right: 1px solid red !important;
}

.row-error-list {
  border-right: 1px solid red !important;
}

.el-tree {
  .el-icon {
    display: none !important;
  }
  .el-tree-node__expand-icon {
    display: none !important;
  }
  .expanded {
    display: none !important;
  }
}

.api-detail-content {
  padding: 20px 0;
}

.api-request-response {
  margin-top: 20px;
}

.code-block {
  background-color: #f5f5f5;
  padding: 15px;
  border-radius: 4px;
  overflow-x: auto;
  font-family: "Courier New", Courier, monospace;
  font-size: 14px;
  line-height: 1.5;
  white-space: pre-wrap;
  word-wrap: break-word;
}

.api-detail-panel {
  width: 100%;
}

.api-header {
  margin-bottom: 20px;
}

.api-name {
  margin-bottom: 10px;
}

.api-desc {
  font-size: 14px;
  color: #666;
  margin-bottom: 10px;
  line-height: 1.4;
}

.api-time {
  font-size: 14px;
  color: #333;
  font-weight: 500;
}

.time-value {
  color: #1890ff;
  font-weight: 600;
}

.detail-item {
  display: flex;
  margin-bottom: 10px;
  font-size: 13px;
}

.detail-label {
  width: 120px;
  color: #999;
  flex-shrink: 0;
}

.detail-value {
  flex: 1;
  color: #333;
  word-break: break-all;
}

.el-collapse {
  margin-top: 15px;
}

.el-collapse-item__content {
  padding: 15px;
  background-color: #f9f9f9;
  border-radius: 4px;
}
</style>
